import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CaretDown = ({ ...rest }) => {
  return (
    <FontAwesomeIcon icon={["fa", "caret-down"]} className="mr-2" {...rest} />
  );
};
